import { useMutation } from 'react-query'
import { request } from '../request'

export const useAuthLogin = () => {
  return useMutation((data: { email: string; password: string; next?: string | null }) =>
    request({
      url: '/auth/login',
      method: 'POST',
      data: data,
    }),
  )
}
